(() => {
/* Silent supplier films; tap or keyboard activation toggles motion without player chrome. */
const filmRail = document.getElementById('film-rail');
const filmCards = [...filmRail.querySelectorAll('.film')];
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const connection = navigator.connection;
const motionRestricted = () => reduceMotion.matches || Boolean(connection?.saveData);

const filmStates = filmCards.map((card, index) => {
  const video = card.querySelector('video');
  const control = card.querySelector('.film-surface');
  const name = index === 0 ? 'glass-cutting video' : 'pattern-and-color video';
  const state = {video, control, visible:false, pausedByUser:false, userStarted:false};
  video.muted = true;
  const updateLabel = () => control.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} ${name}`);
  control.hidden = false;
  control.addEventListener('click', () => {
    state.pausedByUser = !video.paused;
    state.userStarted = !state.pausedByUser;
    syncFilm(state);
  });
  video.addEventListener('play', updateLabel);
  video.addEventListener('pause', updateLabel);
  video.addEventListener('error', () => {
    video.removeAttribute('src');
    video.load();
    state.pausedByUser = true;
    updateLabel();
  });
  return state;
});

function syncFilm(state) {
  if (document.hidden || document.querySelector('.showcase-hero').dataset.obscured === 'true' || !state.visible || state.pausedByUser || (motionRestricted() && !state.userStarted)) {
    state.video.pause();
    return;
  }
  if (!state.video.getAttribute('src')) state.video.src = state.video.dataset.src;
  state.video.play().catch(() => { /* Leave the poster and accessible manual play action available. */ });
}
function syncFilms() { filmStates.forEach(syncFilm); }
const filmObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const state = filmStates.find(item => item.video === entry.target);
    state.visible = entry.isIntersecting && entry.intersectionRatio >= .35;
    syncFilm(state);
  });
}, {threshold:[0,.35]});
filmStates.forEach(state => filmObserver.observe(state.video));
document.addEventListener('visibilitychange', syncFilms);
document.addEventListener('atelier:visibility', syncFilms);
function motionPreferenceChanged() {
  if (motionRestricted()) filmStates.forEach(state => { state.userStarted = false; });
  syncFilms();
}
reduceMotion.addEventListener('change', motionPreferenceChanged);
connection?.addEventListener?.('change', motionPreferenceChanged);

const filmNavigation = document.querySelector('.film-navigation');
const previousFilm = document.getElementById('film-prev');
const nextFilm = document.getElementById('film-next');
function filmIndex() { return Math.round(filmRail.scrollLeft / (filmCards[0].offsetWidth + 14)); }
function updateNavigation() {
  const current = Math.min(filmCards.length - 1, Math.max(0, filmIndex()));
  document.getElementById('film-position').textContent = `${current + 1} / ${filmCards.length}`;
  previousFilm.disabled = current === 0;
  nextFilm.disabled = current === filmCards.length - 1;
}
function moveFilm(direction) {
  const current = Math.min(filmCards.length - 1, Math.max(0, filmIndex() + direction));
  filmRail.scrollTo({left:current * (filmCards[0].offsetWidth + 14),behavior:reduceMotion.matches ? 'instant' : 'smooth'});
}
previousFilm.addEventListener('click', () => moveFilm(-1));
nextFilm.addEventListener('click', () => moveFilm(1));
filmRail.addEventListener('scroll', updateNavigation, {passive:true});
window.addEventListener('resize', updateNavigation);
filmNavigation.hidden = false;

})();
